import { TextField } from '@mui/material';
import React from 'react';
import { ReactComponent as SearchIcon } from '../../../assets/icons/Search.svg';

interface SearchBarProps {
  search_value?: string;
  placeholder?: string;
  variant?: 'standard' | 'outlined';
  handleChangeSearch?: (new_value: string) => void;
}

/**
 * Generalized search bar optionally controlled by parent.
 * @param {string} search_value Optionally set controlled value from parent.
 * @param {string} placeholder Optionally set custom placeholder text for the search bar.
 * @param {'standard' | 'outlined'} variant Optionally control the variant of the MUI input, defaults to standard.
 * @param {(new_value: string): void} handleChangeSearch Update the search value in parent from the input.
 * @returns {JSX.Element}
 */
const SearchBar = ({ search_value, placeholder, variant, handleChangeSearch }: SearchBarProps) => {
  return (
    <TextField
      fullWidth
      variant={variant ? variant : 'standard'}
      placeholder={placeholder ?? 'Search...'}
      slotProps={{
        input: {
          startAdornment: (
            <SearchIcon height={15} style={{ marginRight: 5, fill: 'currentcolor' }} />
          )
        }
      }}
      value={search_value}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
        handleChangeSearch && handleChangeSearch(event.target.value)
      }
    />
  );
};

export default SearchBar;
